document.addEventListener('DOMContentLoaded', function () {
  const openSearchButtons = document.querySelectorAll('.open_desktop_search');
  const searchPopdown = document.getElementById('search-popdown');
  const closeSearchButtons = document.querySelectorAll('.search__predictive__close');

  const openSearch = () => {
    if (searchPopdown) {
      searchPopdown.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
  };

  const closeSearch = () => {
    if (searchPopdown) {
      searchPopdown.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  };

  if (openSearchButtons.length > 0) {
    openSearchButtons.forEach(button => {
      button.addEventListener('click', openSearch);
    });
  }

  if (closeSearchButtons.length > 0) {
    closeSearchButtons.forEach(button => {
      button.addEventListener('click', closeSearch);
    });
  }

  document.addEventListener('click', function (event) {
    if (
      searchPopdown &&
      !searchPopdown.contains(event.target) &&
      ![...openSearchButtons].some(btn => btn.contains(event.target))
    ) {
      closeSearch();
    }
  });
});


document.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');

  if (window.scrollY > 2) {
    header.classList.add('sticky-header');

    setTimeout(() => {
      header.classList.add('sticky-header--visible');
    }, 300);
  } else {
    header.classList.remove('sticky-header');
    setTimeout(() => {
    header.classList.remove('sticky-header--visible'); 
  }, 300);
  }
});




function updateHeaderHeight() {
  const siteHeader = document.querySelector('.nd-header-section');
  const mobileHeaderBottom = document.querySelector('.mobile-al-header-wrapper--bottom');

  if (siteHeader) {
    const headerHeight = siteHeader.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

    if (mobileHeaderBottom) {
      const mobileHeaderBottomHeight = mobileHeaderBottom.offsetHeight;
      const adjustedHeight = headerHeight - mobileHeaderBottomHeight;
      document.documentElement.style.setProperty('--header-height-wo-bottom', `${adjustedHeight}px`);
    }
  }
}


document.addEventListener('DOMContentLoaded', updateHeaderHeight);

window.addEventListener('load', function() {
  setTimeout(updateHeaderHeight, 800);
});

window.addEventListener('resize', updateHeaderHeight);


function updateSubmenuHeight() {
  const submenuElement = document.querySelector('.nd-header-submenu--cards--grid_have--child');

  if (submenuElement) {
    const submenuHeight = submenuElement.offsetHeight;
    document.documentElement.style.setProperty('--submenu-height', `${submenuHeight}px`);
  }
}

document.addEventListener('DOMContentLoaded', updateSubmenuHeight);

window.addEventListener('load', function () {
  setTimeout(updateSubmenuHeight, 800); // Delay to account for late loading elements
});

window.addEventListener('resize', updateSubmenuHeight);





const menuItemsMain = document.querySelectorAll('.nd-header_top_level_link');
const submenusMain = document.querySelectorAll('.nd-header-submenu'); 
const redLineMain = document.querySelector('.nd-menu-black-line-main');
let timeoutMain;

menuItemsMain.forEach((item) => {
  item.addEventListener('mouseenter', (e) => {
    clearTimeout(timeoutMain);
    setRedLinePositionMain(e.target);
  });

  item.addEventListener('mouseleave', () => {
    startRedLineTimeoutMain();
  });
});

submenusMain.forEach((submenu) => {
  submenu.addEventListener('mouseenter', () => clearTimeout(timeoutMain));
  submenu.addEventListener('mouseleave', () => startRedLineTimeoutMain());
});




function setRedLinePositionMain(target) {
  const parent = document.querySelector('.nd-header');
  const parentRect = parent.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();

  const left = targetRect.left - parentRect.left;
  const top = targetRect.bottom - parentRect.top;

  redLineMain.style.width = `${targetRect.width}px`;
  redLineMain.style.left = `${left}px`;
  redLineMain.style.height = '2px';
}


function startRedLineTimeoutMain() {
  timeoutMain = setTimeout(() => {
    redLineMain.style.height = '0px';
  }, 300);
}










document.querySelector('.site-header__hamburger').addEventListener('click', function () {
  this.classList.toggle('mobile_menu_active');
  document.querySelector('.nd-header-mobile').classList.toggle('mobile_menu_active');
  document.querySelector('body').classList.toggle('overflow-hidden');
  document.querySelector('html').classList.toggle('overflow-hidden');
});


document.querySelectorAll('.nd-header-mobile-collapse').forEach(collapseBtn => {
  collapseBtn.addEventListener('click', function () {
    const listItem = this.closest('.nd-header-mobile__list-item--has-dd');
    if (listItem) {
      const dropdown = listItem.querySelector('.nd-header-mobile_submenu--second_level--wrapper');
      this.classList.toggle('collapse_dropdown');
      if (dropdown) {
        dropdown.classList.toggle('collapse_dropdown');
      }
    }
  });
});

document.querySelectorAll('.nd-header-mobile_submenu--second_level--wrapper--top').forEach(closeBtn => {
  closeBtn.addEventListener('click', function () {
    document.querySelectorAll('.nd-header-mobile-collapse.collapse_dropdown').forEach(btn => {
      btn.classList.remove('collapse_dropdown');
    });

    document.querySelectorAll('.nd-header-mobile_submenu--second_level--wrapper.collapse_dropdown').forEach(wrapper => {
      wrapper.classList.remove('collapse_dropdown');
    });
  });
});




document.querySelectorAll('.nd-header-mobile__dropdown-item-scnd-link--open').forEach(button => {
  button.addEventListener('click', function () {
    const isOpen = this.classList.contains('collapse_second_level');

    document.querySelectorAll('.nd-header-mobile__dropdown-item-scnd-link--open').forEach(el => {
      el.classList.remove('collapse_second_level');
    });

    document.querySelectorAll('.nd-header-mobile_submenu--second_level--links').forEach(el => {
      el.classList.remove('collapse_second_level');
    });

    if (!isOpen) {
      this.classList.add('collapse_second_level');

      const parent = this.closest('.nd-header-mobile__dropdown-item');
      if (parent) {
        const submenu = parent.querySelector('.nd-header-mobile_submenu--second_level--links');
        if (submenu) {
          submenu.classList.add('collapse_second_level');
        }
      }
    }
  });
});

